import React, { useMemo } from "react";
import { GameLoader } from "./GameLoader";
import { FxIdWebFeaturesPlayOtaGameVersion } from "../../../Api/gen";
import { getStringEnumValue } from "../../../Utils/Functions";
import { Box } from "@mantine/core";
import { useBuildNumber, useOtaVersion } from "../Hooks";
import { webPlayerStore } from "../store/webPlayerStore";
import { useNormalizedSize } from "@app/Screens/WebPlayer/Hooks/useNormalizedSize";

interface IGameProps {
	onGameLoaded?: () => void;
	disableVersionSelect?: boolean;
	width: number;
	height: number;
	currentAccountId: number;
}

const Game = (props: IGameProps) => {
	log.info("Render Game...");

	const { onGameLoaded, width, height, currentAccountId } = props;
	const [otaVersion] = useOtaVersion();
	const [buildNumber] = useBuildNumber();
	const gameVersion =
		getStringEnumValue(FxIdWebFeaturesPlayOtaGameVersion, otaVersion) ?? FxIdWebFeaturesPlayOtaGameVersion.Release;

	const gameConfig = webPlayerStore((state) => state.gameConfig);
	const { width: normalizedWidth, height: normalizedHeight } = useNormalizedSize(
		width,
		height,
		gameConfig.Presentation
	);

	return (
		<>
			<Box className="game" sx={{ width: normalizedWidth, height: normalizedHeight }}>
				<GameLoader
					gameConfig={gameConfig}
					gameVersion={gameVersion}
					buildNumber={buildNumber}
					onGameLoaded={onGameLoaded}
					currentAccountId={currentAccountId}
					dimensions={{ width: normalizedWidth, height: normalizedHeight }}
				/>
			</Box>
		</>
	);
};

export default React.memo(Game);
